/*=========================================================================================
  File Name: moduleEcommerceState.js
  Description: Ecommerce Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

/* eslint-disable */
export default {
  cartItems: [
    {
      "name": "Nikon - D810 DSLR Camera with AF-S NIKKOR 24-120mm f/4G ED VR Zoom Lens - Black",
      "description": "Shoot arresting photos and 1080p high-definition videos with this Nikon D810 DSLR camera, which features a 36.3-megapixel CMOS sensor and a powerful EXPEED 4 processor for clear, detailed images. The AF-S NIKKOR 24-120mm lens offers shooting versatility. Memory card sold separately.",
      "brand": "Nikon",
      "categories": ["Cameras & Camcorders", "Digital Cameras", "Digital SLR Cameras", "DSLR Body & Lens"],
      "hierarchicalCategories": {
        "lvl0": "Cameras & Camcorders",
        "lvl1": "Cameras & Camcorders > Digital Cameras",
        "lvl2": "Cameras & Camcorders > Digital Cameras > Digital SLR Cameras",
        "lvl3": "Cameras & Camcorders > Digital Cameras > Digital SLR Cameras > DSLR Body & Lens"
      },
      "type": "Dslr cameras",
      "price": 4099.99,
      "price_range": "> 2000",
      "image": "https://cdn-demo.algolia.com/bestbuy-0118/3953409_sb.jpg",
      "url": "https://api.bestbuy.com/click/-/3953409/pdp",
      "free_shipping": true,
      "rating": 4,
      "popularity": 12311,
      "objectID": "3953409",
      "_highlightResult": {
        "name": {
          "value": "Nikon - D810 DSLR Camera with AF-S NIKKOR 24-120mm f/4G ED VR Zoom Lens - Black",
          "matchLevel": "none",
          "matchedWords": []
        },
        "description": {
          "value": "Shoot arresting photos and 1080p high-definition videos with this Nikon D810 DSLR camera, which features a 36.3-megapixel CMOS sensor and a powerful EXPEED 4 processor for clear, detailed images. The AF-S NIKKOR 24-120mm lens offers shooting versatility. Memory card sold separately.",
          "matchLevel": "none",
          "matchedWords": []
        },
        "brand": {"value": "Nikon", "matchLevel": "none", "matchedWords": []},
        "categories": [{
          "value": "Cameras &amp; Camcorders",
          "matchLevel": "none",
          "matchedWords": []
        }, {"value": "Digital Cameras", "matchLevel": "none", "matchedWords": []}, {
          "value": "Digital SLR Cameras",
          "matchLevel": "none",
          "matchedWords": []
        }, {"value": "DSLR Body &amp; Lens", "matchLevel": "none", "matchedWords": []}]
      },
      "quantity": 1,
      "discount_in_percentage": 13,
      "offers_count": 4,
      "delivery_date": "Wed Apr 10"
    },
    {
      "name": "Sony - 75\" Class (74.5\" diag) - LED - 2160p - Smart - 3D - 4K Ultra HD TV with High Dynamic Range - Black",
      "description": "This Sony 4K HDR TV boasts 4K technology for vibrant hues. Its X940D series features a bold 75-inch screen and slim design. Wires remain hidden, and the unit is easily wall mounted. This television has a 4K Processor X1 and 4K X-Reality PRO for crisp video. This Sony 4K HDR TV is easy to control via voice commands.",
      "brand": "Sony",
      "categories": ["TV & Home Theater", "TVs", "4K Ultra HD TVs"],
      "hierarchicalCategories": {
        "lvl0": "TV & Home Theater",
        "lvl1": "TV & Home Theater > TVs",
        "lvl2": "TV & Home Theater > TVs > 4K Ultra HD TVs"
      },
      "type": "Mht 61\"-100\" tv's",
      "price": 4499.99,
      "price_range": "> 2000",
      "image": "https://cdn-demo.algolia.com/bestbuy-0118/4803900_sb.jpg",
      "url": "https://api.bestbuy.com/click/-/4803900/pdp",
      "free_shipping": false,
      "rating": 4,
      "popularity": 20687,
      "objectID": "4803900",
      "_highlightResult": {
        "name": {
          "value": "Sony - 75&quot; Class (74.5&quot; diag) - LED - 2160p - Smart - 3D - 4K Ultra HD TV with High Dynamic Range - Black",
          "matchLevel": "none",
          "matchedWords": []
        },
        "description": {
          "value": "This Sony 4K HDR TV boasts 4K technology for vibrant hues. Its X940D series features a bold 75-inch screen and slim design. Wires remain hidden, and the unit is easily wall mounted. This television has a 4K Processor X1 and 4K X-Reality PRO for crisp video. This Sony 4K HDR TV is easy to control via voice commands.",
          "matchLevel": "none",
          "matchedWords": []
        },
        "brand": {"value": "Sony", "matchLevel": "none", "matchedWords": []},
        "categories": [{"value": "TV &amp; Home Theater", "matchLevel": "none", "matchedWords": []}, {
          "value": "TVs",
          "matchLevel": "none",
          "matchedWords": []
        }, {"value": "4K Ultra HD TVs", "matchLevel": "none", "matchedWords": []}]
      },
      "quantity": 1,
      "discount_in_percentage": 5,
      "offers_count": 2,
      "delivery_date": "Wed Apr 13"
    },
    {
      "name": "Beats by Dr. Dre - Geek Squad Certified Refurbished Beats Studio Wireless On-Ear Headphones - Red",
      "description": "Rock out to your favorite songs with these Beats by Dr. Dre Beats Studio Wireless GS-MH8K2AM/A headphones that feature a Beats Acoustic Engine and DSP software for enhanced clarity. ANC (Adaptive Noise Cancellation) allows you to focus on your tunes.",
      "brand": "Beats by Dr. Dre",
      "categories": ["Audio", "Headphones", "All Headphones"],
      "hierarchicalCategories": {
        "lvl0": "Audio",
        "lvl1": "Audio > Headphones",
        "lvl2": "Audio > Headphones > All Headphones"
      },
      "type": "Refurbished beats",
      "price": 379.99,
      "price_range": "200 - 500",
      "image": "https://cdn-demo.algolia.com/bestbuy-0118/4784058_sb.jpg",
      "url": "https://api.bestbuy.com/click/-/4784058/pdp",
      "free_shipping": false,
      "rating": 4,
      "popularity": 15883,
      "objectID": "4784058",
      "_highlightResult": {
        "name": {
          "value": "<mark>Beats</mark> <mark>by</mark> <mark>Dr.</mark> Dre - Geek Squad Certified Refurbished <mark>Beats</mark> Studio Wireless On-Ear Headphones - Red",
          "matchLevel": "full",
          "fullyHighlighted": false,
          "matchedWords": ["beats", "by", "dr"]
        },
        "description": {
          "value": "Rock out to your favorite songs with these <mark>Beats</mark> <mark>by</mark> <mark>Dr.</mark> Dre <mark>Beats</mark> Studio Wireless GS-MH8K2AM/A headphones that feature a <mark>Beats</mark> Acoustic Engine and DSP software for enhanced clarity. ANC (Adaptive Noise Cancellation) allows you to focus on your tunes.",
          "matchLevel": "full",
          "fullyHighlighted": false,
          "matchedWords": ["beats", "by", "dr"]
        },
        "brand": {
          "value": "<mark>Beats</mark> <mark>by</mark> <mark>Dr.</mark> Dre",
          "matchLevel": "full",
          "fullyHighlighted": false,
          "matchedWords": ["beats", "by", "dr"]
        },
        "categories": [{"value": "Audio", "matchLevel": "none", "matchedWords": []}, {
          "value": "Headphones",
          "matchLevel": "none",
          "matchedWords": []
        }, {"value": "All Headphones", "matchLevel": "none", "matchedWords": []}]
      },
      "quantity": 1,
      "discount_in_percentage": 12,
      "offers_count": 3,
      "delivery_date": "Wed Apr 9"
    },
    {
      "name": "Sony - PlayStation 4 Pro Console",
      "description": "PS4 Pro Dynamic 4K Gaming & 4K Entertainment* PS4 Pro gets you closer to your game. Heighten your experiences. Enrich your adventures. Let the super-charged PS4 Pro lead the way.** GREATNESS AWAITS",
      "brand": "Sony",
      "categories": ["Video Games", "PlayStation 4", "PS4 Consoles"],
      "hierarchicalCategories": {
        "lvl0": "Video Games",
        "lvl1": "Video Games > PlayStation 4",
        "lvl2": "Video Games > PlayStation 4 > PS4 Consoles"
      },
      "type": "Playstation 4 hw",
      "price": 399.99,
      "price_range": "200 - 500",
      "image": "https://cdn-demo.algolia.com/bestbuy-0118/5388900_sb.jpg",
      "url": "https://api.bestbuy.com/click/-/5388900/pdp",
      "free_shipping": true,
      "rating": 4,
      "popularity": 21402,
      "objectID": "5388900",
      "_highlightResult": {
        "name": {
          "value": "<mark>Sony</mark> - <mark>Pla</mark>yStation 4 Pro Console",
          "matchLevel": "full",
          "fullyHighlighted": false,
          "matchedWords": ["sony", "pla"]
        },
        "description": {
          "value": "PS4 Pro Dynamic 4K Gaming &amp; 4K Entertainment* PS4 Pro gets you closer to your game. Heighten your experiences. Enrich your adventures. Let the super-charged PS4 Pro lead the way.** GREATNESS AWAITS",
          "matchLevel": "none",
          "matchedWords": []
        },
        "brand": {
          "value": "<mark>Sony</mark>",
          "matchLevel": "partial",
          "fullyHighlighted": true,
          "matchedWords": ["sony"]
        },
        "categories": [{
          "value": "Video Games",
          "matchLevel": "none",
          "matchedWords": []
        }, {
          "value": "<mark>Pla</mark>yStation 4",
          "matchLevel": "partial",
          "fullyHighlighted": false,
          "matchedWords": ["pla"]
        }, {"value": "PS4 Consoles", "matchLevel": "none", "matchedWords": []}]
      },
      "quantity": 1,
      "discount_in_percentage": 3,
      "offers_count": 1,
      "delivery_date": "Wed Apr 12"
    },
    {
      "name": "Apple - Macbook® (Latest Model) - 12\" Display - Intel Core M5 - 8GB Memory - 512GB Flash Storage - Space Gray",
      "description": "MacBook delivers a full-size experience in the lightest and most compact Mac notebook ever. With a full-size keyboard, force-sensing trackpad, 12-inch Retina display,1 sixth-generation Intel Core M processor, multifunctional USB-C port, and now up to 10 hours of battery life,2 MacBook features big thinking in an impossibly compact form.",
      "brand": "Apple",
      "categories": ["Computers & Tablets", "Laptops", "All Laptops", "MacBooks"],
      "hierarchicalCategories": {
        "lvl0": "Computers & Tablets",
        "lvl1": "Computers & Tablets > Laptops",
        "lvl2": "Computers & Tablets > Laptops > All Laptops",
        "lvl3": "Computers & Tablets > Laptops > All Laptops > MacBooks"
      },
      "type": "Apple",
      "price": 1599.99,
      "price_range": "500 - 2000",
      "image": "https://cdn-demo.algolia.com/bestbuy-0118/5229600_sb.jpg",
      "url": "https://api.bestbuy.com/click/-/5229600/pdp",
      "free_shipping": true,
      "rating": 4,
      "popularity": 19609,
      "objectID": "5229600",
      "_highlightResult": {
        "name": {
          "value": "<mark>Apple</mark> - Macbook® (Latest Model) - 12&quot; Display - Intel Core M5 - 8GB Memory - 512GB Flash Storage - Space Gray",
          "matchLevel": "partial",
          "fullyHighlighted": false,
          "matchedWords": ["apple"]
        },
        "description": {
          "value": "MacBook delivers a full-size experience in the lightest and most compact Mac notebook ever. With a full-size keyboard, force-sensing trackpad, 12-inch Retina display,1 sixth-generation Intel Core M processor, multifunctional USB-C port, and now up to 10 hours of battery life,2 MacBook features big thinking in an impossibly compact form.",
          "matchLevel": "none",
          "matchedWords": []
        },
        "brand": {
          "value": "<mark>Apple</mark>",
          "matchLevel": "partial",
          "fullyHighlighted": true,
          "matchedWords": ["apple"]
        },
        "categories": [{
          "value": "Computers &amp; Tablets",
          "matchLevel": "none",
          "matchedWords": []
        }, {
          "value": "<mark>Laptops</mark>",
          "matchLevel": "partial",
          "fullyHighlighted": true,
          "matchedWords": ["laptop"]
        }, {
          "value": "All <mark>Laptops</mark>",
          "matchLevel": "partial",
          "fullyHighlighted": false,
          "matchedWords": ["laptop"]
        }, {"value": "MacBooks", "matchLevel": "none", "matchedWords": []}]
      },
      "quantity": 1,
      "discount_in_percentage": 7,
      "offers_count": 1,
      "delivery_date": "Wed Apr 14"
    },
    {
      "name": "Apple - Apple Watch Series 1 42mm Space Gray Aluminum Case Black Sport Band - Space Gray Aluminum",
      "description": "Durable, lightweight aluminum cases in silver, space gray, gold, and rose gold. Sport Band in a variety of colors. All the features of the original Apple Watch, plus a new dual-core processor for faster performance. All models run watchOS 3. Requires an iPhone 5 or later.",
      "brand": "Apple",
      "categories": ["Wearable Technology", "Apple Watch", "Apple Watch Series 1"],
      "hierarchicalCategories": {
        "lvl0": "Wearable Technology",
        "lvl1": "Wearable Technology > Apple Watch",
        "lvl2": "Wearable Technology > Apple Watch > Apple Watch Series 1"
      },
      "type": "Standard apple watch",
      "price": 299,
      "price_range": "200 - 500",
      "image": "https://cdn-demo.algolia.com/bestbuy-0118/5546604_sb.jpg",
      "url": "https://api.bestbuy.com/click/-/5546604/pdp",
      "free_shipping": true,
      "rating": 4,
      "popularity": 21419,
      "objectID": "5546604",
      "_highlightResult": {
        "name": {
          "value": "<mark>Apple</mark> - <mark>Apple</mark> Watch Series 1 42mm Space Gray Aluminum Case Black Sport Band - Space Gray Aluminum",
          "matchLevel": "full",
          "fullyHighlighted": false,
          "matchedWords": ["apple"]
        },
        "description": {
          "value": "Durable, lightweight aluminum cases in silver, space gray, gold, and rose gold. Sport Band in a variety of colors. All the features of the original <mark>Apple</mark> Watch, plus a new dual-core processor for faster performance. All models run watchOS 3. Requires an iPhone 5 or later.",
          "matchLevel": "full",
          "fullyHighlighted": false,
          "matchedWords": ["apple"]
        },
        "brand": {
          "value": "<mark>Apple</mark>",
          "matchLevel": "full",
          "fullyHighlighted": true,
          "matchedWords": ["apple"]
        },
        "categories": [{
          "value": "Wearable Technology",
          "matchLevel": "none",
          "matchedWords": []
        }, {
          "value": "<mark>Apple</mark> Watch",
          "matchLevel": "full",
          "fullyHighlighted": false,
          "matchedWords": ["apple"]
        }, {
          "value": "<mark>Apple</mark> Watch Series 1",
          "matchLevel": "full",
          "fullyHighlighted": false,
          "matchedWords": ["apple"]
        }],
        "type": {
          "value": "Standard <mark>apple</mark> watch",
          "matchLevel": "full",
          "fullyHighlighted": false,
          "matchedWords": ["apple"]
        }
      },
      "quantity": 1,
      "discount_in_percentage": 17,
      "offers_count": 4,
      "delivery_date": "Wed Apr 15"
    },
  ],
  wishList: [
        {
      "name": "Reis Pilavlik (Osmancik) Rice",
      "description":  "Pilavlik rice",
      "brand": "Reis",
      "categories": "Dry Goods",
      "hierarchicalCategories": {
        "lvl0": "Dry Goods"
      },
      "type": "",
      "price": 49.99,
      "price_range": "> 2000",
      "image": "https://cdn.pepperi.com/WrntyImages/30011440/PortfolioItems/0/44434510_1_200x200.jpg",
      "url": "https://api.bestbuy.com/click/-/4039001/pdp",
      "free_shipping": false,
      "rating": 4,
      "popularity": 17400,
      "objectID": "4039001",
      "_highlightResult": {
        "name": {
          "value": "Samsung - Chef Collection 34.3 Cu. Ft. 4-Door Flex French Door Refrigerator with Thru-the-Door Ice and Water - Stainless Steel",
          "matchLevel": "none",
          "matchedWords": []
        },
        "description": {
          "value": "Samsung 34.3 Cu. Ft. Frost-Free 4-Door Flex French Door Refrigerator with Thru-the Door Ice and Water: Take the utmost care of your ingredients, and keep them all organized, with this ultralarge-capacity Chef Collection refrigerator. It features 2 compressors, 3 evaporators and 4 temperature zones, keeping foods at their optimum temperature for freshness and flavor.",
          "matchLevel": "none",
          "matchedWords": []
        },
        "brand": {"value": "Samsung", "matchLevel": "none", "matchedWords": []},
        "categories": [{"value": "Appliances", "matchLevel": "none", "matchedWords": []}, {
          "value": "Refrigerators",
          "matchLevel": "none",
          "matchedWords": []
        }, {"value": "All Refrigerators", "matchLevel": "none", "matchedWords": []}]
      }
    },
    {
      "name": "Basak Baking Powder",
      "description": "Baking powder",
      "brand": "Basak",
      "categories": "Baking Agents",
      "hierarchicalCategories": {
        "lvl0": "Baking Agents"
      },
      "type": "",
      "price": 43.99,
      "price_range": "> 2000",
      "image": "https://cdn.pepperi.com/WrntyImages/30011440/PortfolioItems/6/44434346_1_200x200.jpg",
      "url": "https://api.bestbuy.com/click/-/5578528/pdp",
      "free_shipping": true,
      "rating": 4,
      "popularity": 16298,
      "objectID": "5578528",
    },
    {
      "name": "Honey Brother Creamed Honey",
      "description": "2LB Creamed honey",
      "brand": "Honey Brother",
      "categories": "Honey & Sugar",
      "hierarchicalCategories": {"lvl0": "Honey & Sugar"},
      "type": "",
      "price": 31.99,
      "price_range": "> 2000",
      "image": "https://cdn.pepperi.com/WrntyImages/30011440/PortfolioItems/9/44433379_1_200x200.jpg",
      "url": "https://api.bestbuy.com/click/-/5622404/pdp",
      "free_shipping": true,
      "rating": 4,
      "popularity": 16050,
      "objectID": "5622404",
    },
    {
      "name": "Al Wadi Tahin Pail",
      "description": "1Kg Tahina",
      "brand": "Al Wadi",
      "categories": "Tahini & Syrups",
      "hierarchicalCategories": {"lvl0": "Tahini & Syrups"},
      "type": "Streaming media plyr",
      "price": 39.99,
      "price_range": "1 - 50",
      "image": "https://cdn.pepperi.com/WrntyImages/30011440/PortfolioItems/9/44433549_1_200x200.jpg",
      "url": "https://api.bestbuy.com/click/-/5477500/pdp",
      "free_shipping": false,
      "rating": 4,
      "popularity": 21469,
      "objectID": "5477500",
    },
    {
      "name": "Olio Villa Pomace Oil 1GL Can",
      "description": "Olive oil",
      "brand": "Olio",
      "categories": ["Computers & Tablets", "Laptops"],
      "hierarchicalCategories": {"lvl0": "Oil"},
      "type": "Oil",
      "price": 19.99,
      "price_range": "500 - 2000",
      "image": "https://cdn.pepperi.com/WrntyImages/30011440/PortfolioItems/3/44434563_1_200x200.jpg",
      "url": "https://api.bestbuy.com/click/-/5713010/pdp",
      "free_shipping": false,
      "rating": 0,
      "popularity": 14033,
      "objectID": "5713010",

    },
    {
      "name": "Penguen Jalapeno Pepper Pickles",
      "description": "Jalapeno pepper pickles",
      "brand": "Penguen",
      "categories": "Pickles",
      "hierarchicalCategories": {
        "lvl0": "Pickles"
      },
      "type": "",
      "price": 64.99,
      "price_range": "500 - 2000",
      "image": "https://cdn.pepperi.com/WrntyImages/30011440/PortfolioItems/6/44434646_1_200x200.jpg",
      "url": "https://api.bestbuy.com/click/-/4922801/pdp",
      "free_shipping": true,
      "rating": 4,
      "popularity": 12115,
      "objectID": "4922801",

    },
    {
      "name": "Mis Pepper Paste Hot 1900GR",
      "description": "Jarred pepper paste",
      "brand": "Mis",
      "categories": "Canned & Jarred",
      "hierarchicalCategories": {
        "lvl0": "Canned & Jarred"
      },
      "type": "Paste",
      "price": 59.99,
      "price_range": "500 - 2000",
      "image": "https://cdn.pepperi.com/WrntyImages/30011440/PortfolioItems/9/44433419_1_200x200.jpg",
      "url": "https://www.vintagefood.com/#/item/44433419",
      "free_shipping": false,
      "rating": 0,
      "popularity": 12534,
      "objectID": "5714479",
      "_highlightResult": {
        "name": {
          "value": "Mis Pepper Paste Hot 1900GR",
          "matchLevel": "none",
          "matchedWords": []
        },
        "description": {
          "value": "Jarred pepper paste",
          "matchLevel": "none",
          "matchedWords": []
        },
        "brand": {"value": "Mis", "matchLevel": "none", "matchedWords": []},
        "categories": [{
          "value": "Canned & Jarred",
          "matchLevel": "none",
          "matchedWords": []
        }]
      }
    },
    {
      "name": "Merve Beef Soujouk Hot Round 1LB",
      "description": "1LB Soujouk",
      "brand": "Merve",
      "categories": "Meat",
      "hierarchicalCategories": {
        "lvl0": "Meat"
      },
      "type": "Raw",
      "price": 45.99,
      "price_range": "100 - 200",
      "image": "https://cdn.pepperi.com/WrntyImages/30011440/PortfolioItems/1/44434791_1_200x200.jpg",
      "url": "https://www.vintagefood.com/#/item/44434791",
      "free_shipping": false,
      "popularity": 9059,
      "rating": 4,
      "objectID": "5565002"
    },
    {
      "name": "Kral Bulbul Yuvasi Kadayif 300GR",
      "description": "300gr kadayif",
      "brand": "Kral",
      "categories": "Bakery & Ingredients",
      "hierarchicalCategories": {
        "lvl0": "Bakery & Ingredients"
      },
      "type": "Raw",
      "price": 49.99,
      "price_range": "> 2000",
      "image": "https://cdn.pepperi.com/WrntyImages/30011440/PortfolioItems/8/44433768_1_200x200.jpg",
      "url": "https://www.vintagefood.com/#/item/44433768",
      "free_shipping": false,
      "rating": 1,
      "popularity": 9684,
      "objectID": "5582501",
      "_highlightResult": {
        "name": {
          "value": "Kral Bulbul Yuvasi Kadayif 300GR",
          "matchLevel": "none",
          "matchedWords": []
        },
        "description": {
          "value": "300GR kadayif",
          "matchLevel": "none",
          "matchedWords": []
        },
        "brand": {"value": "Kral", "matchLevel": "none", "matchedWords": []},
        "categories": [{"value": "Bakery & Ingredients", "matchLevel": "none", "matchedWords": []}]
      }
    },
    {
      "name": "Merve Gunluk Taze Yufka 1KG",
      "description": "1KG taze gunluk yufka",
      "brand": "Merve",
      "categories": "Bakery & Ingredients",
      "hierarchicalCategories": {
        "lvl0": "Bakery & Ingredients"
      },
      "type": "Raw",
      "price": 19.99,
      "price_range": "1 - 50",
      "image": "https://cdn.pepperi.com/WrntyImages/30011440/PortfolioItems/6/45718706_1_200x200.jpg",
      "url": "https://www.vintagefood.com/#/item/45718706",
      "free_shipping": true,
      "rating": 4,
      "popularity": 21400,
      "objectID": "8618232",
      "_highlightResult": {
        "name": {
          "value": "Merve Gunluk Taze Yufka 1KG",
          "matchLevel": "none",
          "matchedWords": []
        },
        "description": {
          "value": "1KG taze gunluk yufka",
          "matchLevel": "none",
          "matchedWords": []
        },
        "brand": {"value": "Merve", "matchLevel": "none", "matchedWords": []},
        "categories": [{"value": "Bakery & Ingredients", "matchLevel": "none", "matchedWords": []}],
        "type": {"value": "Raw", "matchLevel": "none", "matchedWords": []}
      }
    }
  ]
}
/* eslint-enable */
